export const getFlightsRebookRoutes = () => {
  const BASE_ROUTE = `/flights/rebook`;

  const ROUTE_SEGMENTS = {
    SUMMARY: "summary",
    FLIGHTS: {
      DEPARTURE: "departure",
      RETURN: "return",
    },
    REVIEW: "review",
    CONFIRMATION: "confirmation",
  };

  const FULL_ROUTES = {
    SUMMARY: `${BASE_ROUTE}/${ROUTE_SEGMENTS.SUMMARY}`,
    FLIGHTS: {
      DEPARTURE: `${BASE_ROUTE}/${ROUTE_SEGMENTS.FLIGHTS.DEPARTURE}`,
      RETURN: `${BASE_ROUTE}/${ROUTE_SEGMENTS.FLIGHTS.RETURN}`,
    },
    REVIEW: `${BASE_ROUTE}/${ROUTE_SEGMENTS.REVIEW}`,
    CONFIRMATION: `${BASE_ROUTE}/${ROUTE_SEGMENTS.CONFIRMATION}`,
  };

  return {
    BASE_ROUTE,
    ROUTE_SEGMENTS,
    FULL_ROUTES,
  };
};
